import React from 'react';
import HelpContent from './HelpContent';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const ElectrificacionFinalComercialHelp = () => (
  <HelpContent>
   <h1>Electrificación de usos finales del sector comercial</h1>
   <p>
    Esta medida evalua el impacto de la electrificación de los usos finales del sector comercial. La medida consiste en el reemplazo de calefacción en base a gas (natural y licuado) en el comercio,
     por ejemplo, restaurantes, clínicas, comercios, malls, etc, por equipos de calefacción eléctricos de mayor eficiencia y considera la electrificación de usos motrices en el sector comercial,
      reemplazando del uso de diésel por el uso de electricidad. Por usos motrices se consideran todos los procesos que utilizan tecnología que involucren fuerzas mecánicas, fijas o móviles; concepto que,
       en este segmento, considera principalmente actividades de transporte de carga al interior de los establecimientos. 
    </p>
    <p>
    <strong>Trayectoria 1:</strong> 
    </p>
    <p>
    Calefacción: aumento de la participación de electricidad en calefacción de 13% en 2030 y un 76% en 2050.
    </p>
    <p>
    Uso motriz: aumento de la participación de electricidad en usos motrices de 11% en 2030 y un 56% en 2050.
    </p>
    <p>
    <strong>Trayectoria 2:</strong> 
    </p>
    <p>
    Calefacción: aumento de la participación de electricidad en calefacción de 13% en 2030 y un 76% en 2050.
    </p>
    <p>
    Uso motriz: aumento de la participación de electricidad en usos motrices de 11% en 2030 y un 70% en 2050.
    </p>
  </HelpContent>
);

export default ElectrificacionFinalComercialHelp;
